import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { provideRouter, RouteReuseStrategy, withRouterConfig } from '@angular/router';
import { MsalService, MsalGuard, MSAL_INSTANCE, MSAL_GUARD_CONFIG, MsalBroadcastService } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { routes } from './app/app.routes';
import { inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { AuthInterceptor } from './app/services/auth-interceptor';
import { environment } from './environments/environment';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NoReuseStrategy } from './app/no-reuse-strategy';

export function MSALInstanceFactory(): PublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: environment.azureAdB2c.clientId,
            authority: `https://${environment.azureAdB2c.tenantName}.b2clogin.com/${environment.azureAdB2c.tenantName}.onmicrosoft.com/${environment.azureAdB2c.signIn}`,
            redirectUri: environment.azureAdB2c.redirectUri,
            knownAuthorities: [`${environment.azureAdB2c.tenantName}.b2clogin.com`],
        },
        cache: {
            cacheLocation: 'localStorage',
            storeAuthStateInCookie: true,
        },
    });
}

export function MSALGuardConfigFactory() {
    return {
        interactionType: InteractionType.Popup,
        authRequest: {
            scopes: ['openid', 'profile', 'offline_access', 'User.Read'],
        },
    };
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),
        { provide: RouteReuseStrategy, useClass: NoReuseStrategy },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideAnimations(),
        { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
        { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        // Ensures MSAL initializes before app bootstrap. MSAL_INSTANCE is
        // typed as InjectionToken<string> in @azure/msal-angular itself, but
        // the provider below supplies a real PublicClientApplication.
        provideAppInitializer(() => (inject(MSAL_INSTANCE) as unknown as PublicClientApplication).initialize()),
        MsalService,
        MsalGuard,
        MsalBroadcastService,
    ],
});
